<template>
    <div>
        <!-- start page title -->
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Blogs</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            <li class="breadcrumb-item"><a href="/">Frontend Settings</a>
                            </li>
                            <li class="breadcrumb-item active">Blogs
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <!-- end page title -->

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">{{ isEditing ? 'Edit' : 'Add' }} Blog</h4>
                    </div>
                    <div class="card-body">
                        <validation-errors></validation-errors>
                        <form @submit.prevent="isEditing ? updateBlog() : createBlog()">
                            <div class="row">
                                <div class="col-6 mb-3">
                                    <label for="title" class="form-label">Title</label>
                                    <input class="form-control" type="text" id="title"
                                           placeholder="e.g The Human brain" v-model="post.title">
                                </div>

                                <div class="col-6 mb-3">
                                    <label for="metaTitle" class="form-label">Meta Title</label>
                                    <input class="form-control" type="text" id="metaTitle"
                                           placeholder="e.g The Human brain" v-model="post.metaTitle">
                                </div>

                            </div>

                            <div class="row">

                                <div class=" col-6 mb-3">
                                    <label for="title" class="form-label">Meta Description</label>
                                    <textarea class="form-control" name="meta_description" id="meta_description"
                                              cols="30"
                                              rows="2`" v-model="post.metaDescription"></textarea>
                                </div>

                                <div class="col-6 mb-3">
                                    <label class="form-label">Blog Post Image</label>

                                    <file-pond
                                        v-if="true"
                                        name="test"
                                        ref="blogImage"
                                        label-idle="Drag & drop blog image"
                                        accepted-file-types="image/jpeg, image/png, image/gif"
                                        data-allow-reorder="true"
                                        data-max-file-size="2MB"
                                        :files="blogImage"
                                    />
                                </div>
                            </div>


                            <div class="mb-3">
                                <label for="title" class="form-label">Content</label>
                                <vue-editor v-model="post.content"></vue-editor>
                            </div>

                            <div class="row">
                                <div class="col-md-4 col-xs-12">
                                    <button type="submit" class="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import {VueEditor} from "vue2-editor";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import ValidationErrors from "../../Shared/ValidationErrors";


const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview
);

export default {
    metaInfo: {title: 'Posts'},
    props: ['isEditing', 'posts'],
    layout: Layout,
    components: {
        VueEditor,
        FilePond,
        ValidationErrors
    },
    data: () => ({
        post: {
            type: ''
        },
        saving: false,
        blogImage: [],
    }),
    methods: {
        async createBlog() {
            this.saving = true;
            let vm = this;

            try {
                const formData = new FormData();
                const uploadedFiles = this.$refs.blogImage.getFiles();

                if (uploadedFiles.length > 0) {
                    uploadedFiles.forEach(file => formData.append('image', file.file));
                }
                // add post key value pair
                Object.keys(this.post).forEach(post => formData.append(post, this.post[post]));

                this.$inertia.post(route('admin.cms.blogs.store'), formData, {
                    preserveScroll: true,
                    onError: () => vm.saving = false,
                    onSuccess: () => vm.saving = false,
                })

            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
        async updateBlog() {
            this.saving = true;
            try {
                const formData = new FormData();

                let updatedData = {
                    title: this.post.title,
                    metaTitle: this.post.metaTitle,
                    metaDescription: this.post.metaDescription,
                    content: this.post.content,
                    type: this.post.type
                }

                Object.keys(updatedData).forEach(blog => formData.append(blog, updatedData[blog]));

                if (this.$refs.blogImage.getFile().source !== this.$refs.blogImage.files) {
                    const uploadedFiles = this.$refs.blogImage.getFiles();
                    uploadedFiles.forEach(file => formData.append('image', file.file));
                }

                this.$inertia.post(route('cms.blogs.update', this.post.id), formData)
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },
    },
    mounted() {
        if (this.isEditing) {
            this.post = this.posts;
            this.post.metaDescription = this.posts.meta_description;
            this.post.metaTitle = this.posts.meta_title;
            this.blogImage = this.posts.image;
        }
    }
}
</script>

<style scoped>

</style>
